<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="dispatchPublish">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem
            @action="changeStatus"
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
          >
          </businessItem>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup
      class="bidPopUp"
      v-model="show"
      closeable
      round
      :style="{ height: '320px', width: '320px' }"
    >
      <p class="popUpTitle">修改业务计划：</p>
      <!-- <div class="pickUnit" @click="showUnit =true">
        <p>{{currentUnit.transitPort}}</p>
      </div> -->
      <div class="staffGauge" @click="showUnit = true">
        <van-field
          required
          v-model="currentRow.transitPort"
          readonly
          placeholder="请输入中转港"
          label-width="80px"
          border
          type="input"
          label="中转港"
        />
      </div>
      <div class="staffGauge">
        <van-field
          required
          v-model="currentRow.staffGauge"
          placeholder="水尺数/吨"
          label-width="80px"
          border
          type="number"
          label="水尺数/吨"
        />
      </div>
      <div class="staffGauge">
        <van-field
          autocomplete="off"
          v-model="currentRow.planTime"
          name="picker"
          label="海轮离港日期"
          placeholder="请选择海轮离港日期"
          readonly
          @click="planyue"
          :rules="[{ required: true, message: '请选择海轮离港日期' }]"
          right-icon="arrow-down"
        />
      </div>
      <div class="staffGauge">
        <van-field
          readonly
          clickable
          label-width="120"
          :value="datali"
          label="长江口预抵时间"
          placeholder="请选择时间"
          @click="uidata = true"
          class="fieldke"
        />
      </div>

      <!-- 预计到达长江口时间 -->

      <van-button class="unitButton" type="primary" @click="submit"
        >更新</van-button
      >
    </van-popup>
    <van-popup v-model="pandata" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate1"
        type="date"
        title="海轮离港日期"
        :min-date="minDate1"
        :max-date="maxDate1"
        @confirm="panlick"
        @cancel="canceldata"
      />
    </van-popup>
    <van-popup v-model="uidata" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="请选择日期时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onuidata"
        @cancel="uidata = false"
        :formatter="formattera"
      />
    </van-popup>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择中转港"
        :columns="transferssList"
        @confirm="onConfirm"
        value-key="name"
        @cancel="onCancel"
      />
    </van-popup>
    <!-- <van-popup
      v-model="showUnit"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="选择中转港"
        :columns="portList"
        @confirm="onConfirm"
        value-key="label"
        @cancel="onCancel"
      />
    </van-popup> -->
    <van-overlay :show="showUnbid" z-index="999999999999">
      <div class="wrapper">
        <div class="block">
          <img
            src="../../../../assets/audit/x.png"
            class="icon"
            @click="onClickIcon"
          />
          <p class="title">是否废标</p>
          <div class="reject" @click="onClickState(1)">取消</div>
          <div class="pass" @click="onClickState(2)">废标</div>
        </div>
      </div>
    </van-overlay>
    <van-notify v-model="showNotice">
      <span>{{ noticeMessage }}</span>
    </van-notify>
    <van-popup class="jsbdh" v-model="bidder" closeable round>
      <p class="popUpTitle">预装时间：</p>
      <div class="pickUnit" @click="datastuli = true">
        <p>{{ currentUnit.loadDate }}</p>
      </div>
      <p class="popUpTitle">货物种类：</p>
      <div class="pickUnit" @click="goodsli = true">
        <p>{{ currentUnit.goodsType }}</p>
      </div>
      <p class="popUpTitle">承运单位：</p>
      <div class="pickUnit" @click="showShipperli = true">
        <p>{{ currentUnit.shipperName }}</p>
      </div>

      <p class="popUpTitle">中标单位：</p>
      <div class="pickUnit" @click="showUnitli = true">
        <p>{{ currentUnit.comp }}</p>
      </div>
      <p class="popUpTitle">运输单位：</p>
      <div class="pickUnit" @click="showUnitcarli = true">
        <p>{{ currentUnit.cargoOwner }}</p>
      </div>
      <van-button class="unitButton" type="primary" @click="submitcur"
        >更新</van-button
      >
    </van-popup>

    <van-popup
      v-model="showUnitli"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="选择中标单位"
        :columns="unitList"
        @confirm="onConfirmli"
        value-key="comp"
        @cancel="onCancelli"
      />
    </van-popup>
    <van-popup
      v-model="showUnitcarli"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="选择运输单位"
        :columns="unitList"
        @confirm="onConfirmCarg"
        value-key="comp"
        @cancel="onCancelcar"
      />
    </van-popup>
    <van-popup v-model="goodsli" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="物种种类"
        :columns="typegoodLi"
        @confirm="ongoods"
        value-key="dictLabel"
        @cancel="cangoods"
      />
    </van-popup>
    <van-popup v-model="datastuli" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="ondatastu"
        @cancel="centastu"
      />
    </van-popup>
    <van-popup
      v-model="showShipperli"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="选择承运单位"
        :columns="unitList"
        @confirm="onConfirmShipper"
        value-key="comp"
        @cancel="onCancelShipper"
        :default-index="defaultShipperIndex"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  dispatchPlanList,
  dispatchGetPort,
  dispatchUpdatePlan,
  dispatchPlanUnBind,
  transferss,
  getBindUnitList,
  gettypegood,
  updateBidUnit
} from "@/utils/network/interface";
import businessItem from "./item";
export default {
  name: "bidWin",
  components: {
    businessItem,
  },
  props: {
    keyWord: String,
  },
  data() {
    return {
      datali: "",
      uidata: false,
      minDate: new Date(),
      maxDate: new Date(2040, 10, 1),
      currentDate: new Date(),
      //
      typegoodLi: [],
      unitList: [],
      tableList: [],
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      
      show: false,
      showUnit: false,
      currentRow: {},
      showNotice: false,
      noticeMessage: "",
      portList: [],
      transferssList: [],
      showUnbid: false,
      //
      // 计划月份
      minDate1: new Date(2019, 0),
      maxDate1: new Date(2050, 12),
      currentDate1: new Date(this.formatter()),
      currlist: this.formatter(),
      pandata: false,

      // 更新中标
      bidder: false,
      currentUnit: {
        cargoOwnerId: null,
        cargoOwner: "",
        comp: "",
        goodsType: "",
        id: null,
        loadDate: "",
        shipperId: 6,
        shipperName: null,
        bidderId: "",
      },

      datastuli: false,
      goodsli: false,
      showShipperli: false,
      showUnitli: false,
      showUnitcarli: false,
      defaultShipperIndex: 0,
    };
  },
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.tableList = [];
      this.onLoad();
    },
  },
  created() {
    this.transferssfrom();
    this.getUnitList();
    this.gettypegoodList();
  },
  mounted() {},
  methods: {
    gettypegoodList() {
      gettypegood().then((res) => {
        this.typegoodLi = res.data;
      });
    },
    getUnitList() {
      getBindUnitList().then((res) => {
        this.unitList = res.data;
        console.log(res, "res");
        //承运单位默认值
        if (this.unitList) {
          this.unitList.filter((value, index) => {
            if (value.id === 6) {
              this.defaultShipperIndex = index;
              this.currentUnit.shipperId = value.id;
              this.currentUnit.shipperName = value.comp;
            }
          });
        }
      });
    },
    // 选择年月
    ondatastu(va) {
      let data_v = new Date(va);
      let date_value =
        data_v.getFullYear() +
        "-" +
        (data_v.getMonth() + 1) +
        "-" +
        data_v.getDate();
      this.currentUnit.loadDate = date_value;

      this.datastuli = false;
    },
    centastu() {
      this.datastuli = false;
    },
    // 物种种类
    ongoods(va) {
      console.log(va.dictLabel);
      this.currentUnit.goodsType = va.dictLabel;
      this.goodsli = false;
    },
    cangoods() {
      this.goodsli = false;
    },
    // 运输
    onConfirmCarg(value, index) {
      // this.currentUnit.id = this.unitList[index].id;
      this.currentUnit.cargoOwner = this.unitList[index].comp;
      this.currentUnit.cargoOwnerId = this.unitList[index].id;
      console.log(this.unitList);
      this.showUnitcarli = false;
    },
    onCancelcar() {
      this.showUnitcarli = false;
    },
    // 中标
    onConfirmli(value, index) {
      // console.log(value,index)
      this.currentUnit.bidderId = this.unitList[index].id;
      this.currentUnit.comp = this.unitList[index].comp;
      // this.currentUnit.cargoOwnerId = this.unitList[index].cargoOwnerId
      console.log(this.unitList);
      this.showUnitli = false;
    },
    onCancelli() {
      this.showUnitli = false;
    },
    //承运单位选择
    onConfirmShipper(value, index) {
      this.currentUnit.shipperId = value.id;
      this.currentUnit.shipperName = value.comp;
      this.showShipperli = false;
    },
    onCancelShipper() {
      this.showShipperli = false;
    },
    //
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { state: 1, pageSize, pageNum, bizName: this.keyWord };
        dispatchPlanList(obj)
          .then((res) => {
            if (res.code === 200) {
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = { state: 1, pageSize: 10, pageNum: 1, bizName: this.keyWord };
      dispatchPlanList(obj)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            this.tableList = res.rows;
            this.pageInfo.pageNum++;
            this.pageInfo.total = res.total;
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
    },
    changeStatus(data, methods) {
      this.currentRow = data;
      this.datali = data.yuCjkTime;
      this.currentUnit.loadDate = data.loadDate;
      this.currentUnit.goodsType = data.goodsType;
      this.currentUnit.cargoOwner = data.cargoOwner;
      
      this.currentUnit.cargoOwnerId = data.cargoOwnerId;
      this.currentUnit.bidderId = data.bidderId;
      this.currentUnit.id = data.palletsId;
      this.currentUnit.comp = data.bidderName;
      console.log(data, methods);
      if (methods == 2) {
        this.showUnbid = true;
      } else if (methods == 3) {
        this.show = true;
      } else if (methods == 4) {
        this.bidder = true;
      }
    },
    submit() {
      if (!this.currentRow.staffGauge) {
        this.showNotice = true;
        this.noticeMessage = "请输入水尺数/吨";
        setTimeout(() => {
          this.showNotice = false;
          this.noticeMessage = "";
        }, 2000);
      } else if (!this.currentRow.transitPort) {
        this.showNotice = true;
        this.noticeMessage = "请选择中转港";
        setTimeout(() => {
          this.showNotice = false;
          this.noticeMessage = "";
        }, 2000);
      } else {
        let data = {
          id: this.currentRow.id,
          staffGauge: this.currentRow.staffGauge,
          transitPort: this.currentRow.transitPort,
          planTime: this.currentRow.planTime,
          yuCjkTime: this.datali,
        };
        dispatchUpdatePlan(data).then((res) => {
          if (res.code !== 200) {
            this.$toast({
              type: "fail",
              message: res.msg,
            });
          } else {
            this.currentRow = {};
            this.currentUnit = "";
            this.show = false;
            this.onRefresh();
          }
        });
      }
    },
      submitcur() {
      if (!this.currentUnit.id) {
        this.showNotice = true;
        setTimeout(() => {
          this.showNotice = false;
        }, 2000);
      } else {
        let params = {
          cargoOwnerId: this.currentUnit.cargoOwnerId,
         bidderId: this.currentUnit.bidderId,
          comp: this.currentUnit.comp,
          id: this.currentUnit.id,
          loadDate: this.currentUnit.loadDate,
          goodsType: this.currentUnit.goodsType,
          shipperId: this.currentUnit.shipperId,
          shipperName: this.currentUnit.shipperName,
        };
        updateBidUnit(params).then((res) => {
          // console.log(res)
          if (res.code !== 200) {
            this.$toast({
              type: "fail",
              message: res.msg,
            });
          } else {
            this.$toast({
              type: "success",
              message: "修改成功",
            });
            this.currentRow = {};
            this.currentUnit = {};
            this.bidder = false;
            this.getData();
          }
        });
      }
    },
    onConfirm(vale) {
      console.log(vale.name);
      this.currentRow.transitPort = vale.name;
      this.showUnit = false;
    },
    onCancel() {
      this.showUnit = false;
    },
    transferssfrom() {
      transferss().then((res) => {
        this.transferssList = res.data;
      });
    },
    onClickIcon() {
      this.showUnbid = false;
    },
    onClickState(type) {
      if (type == 1) {
        this.showUnbid = false;
        return;
      } else {
        dispatchPlanUnBind({ id: this.currentRow.id })
          .then((res) => {
            this.showUnbid = false;
            if (res.code === 200) {
              this.$toast.success("废标成功");
              this.getData();
            }
          })
          .finally((res) => {
            this.showUnbid = false;
          });
      }
    },
    onuidata(va) {
      console.log(va, "10");
      var y = va.getFullYear();
      var m = va.getMonth() + 1;
      var d = va.getDate();
      var h = va.getHours();
      var m1 = va.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      m1 = m1 < 10 ? "0" + m1 : m1;
      let datali = y + "-" + m + "-" + d + " " + h + ":" + m1;
      this.datali = datali;
      console.log(datali, "44");
      // this.currentRow.yuCjkTime = datali;
      this.uidata = false;
    },
    formattera(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      //  else if (type === "hour") {
      //   return `${val}时`;
      // } else if (type === "minute") {
      //   return `${val}分`;
      // }
      return val;
    },
    // 计划月份
    planyue() {
      this.pandata = true;
    },
    panlick(time) {
      this.currentRow.planTime = this.formatter(time);
      this.pandata = false;
    },
    canceldata() {
      this.pandata = false;
    },
    formatter(time) {
      let nowdata = time == null ? new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
  },
};
</script>

<style lang="less" scoped>
.dispatchPublish {
  .bidPopUp {
    padding: 20px 10px;

    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;
    }

    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../../assets/accountant/selectDown.png")
        calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 25px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 40px auto 0;
      border: 1px solid #44b1f9;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;

    .block {
      width: 269px;
      height: 165px;
      background: url("../../../../assets/icon/layoutBg.png") 0 0 no-repeat #fff;
      background-size: 269px 61px;
      border-radius: 10px;
      position: relative;

      .icon {
        width: 11px;
        height: 11px;
        float: right;
        right: 16px;
        top: 25px;
        position: absolute;
      }

      .title {
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-top: 45px;
        margin-bottom: 55px;
        line-height: 1;
      }

      .reject {
        width: 87px;
        height: 28px;
        border: 1px solid #f7b346;
        border-radius: 5px;
        color: #f7b346;
        text-align: center;
        line-height: 28px;
        float: left;
        margin-left: 40px;
      }

      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin-left: 20px;
      }
    }
  }
  .jsbdh {
    padding: 20px;
    width: 80%;
    height: 420px;

    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 600;
      text-align: left;
      color: #333333;
      line-height: 18px;
      margin-bottom: 10px;
    }

    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../../assets/accountant/selectDown.png")
        calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 10px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 0 auto;
      border: 1px solid #44b1f9;
    }
  }
}
</style>
<style lang="less">
.dispatchPublish {
  .staffGauge {
    text-align: left;
    margin-bottom: 10px;

    .van-cell {
      padding: 0;

      .van-cell__title {
        margin-right: 0;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        text-align: left;
      }

      .van-cell__value {
        border: 1px solid #44b1f9;
        border-radius: 5px;
        height: 30px;
        line-height: 28px;
        padding: 0 10px;
        font-size: 14px;
      }

      &.van-cell--required::before {
        left: 0;
        line-height: 30px;
        top: 0;
        height: 30px;
      }
    }
  }
}
</style>